import { useEffect, useId, useRef } from 'react';
import './Dialog.css';

// Small modal used for messages that need to interrupt the customer, rather
// than sit next to a control where they can be missed or squeeze the layout.
const Dialog = ({ open, title, message, actions, onClose }) => {
  const titleId = useId();
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);
    closeRef.current?.focus();

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className="dialog-backdrop" role="presentation" onClick={onClose}>
      <div
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={event => event.stopPropagation()}
      >
        <h2 className="dialog-title" id={titleId}>
          {title}
        </h2>
        <p className="dialog-message">{message}</p>
        <div className="dialog-actions">
          {actions}
          <button
            type="button"
            className="dialog-button dialog-button-primary"
            ref={closeRef}
            onClick={onClose}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
